import type { ReactNode } from "react";
import { Box, BoxProps, Skeleton } from "@chakra-ui/react";
import { NA } from "components/Shared/EmptyPlaceholder";

type Props = BoxProps & {
  isLoading?: boolean;
  label: ReactNode;
  value: ReactNode;
};

export default function CalculatedField({
  isLoading,
  label,
  value,
  ...rest
}: Props) {
  return (
    <Box fontSize="sm" color="gray.600" textAlign="right" {...rest}>
      {label}:{" "}
      <Skeleton
        isLoaded={(value !== null && value !== undefined) || !isLoading}
        display="inline-block"
      >
        {value !== null && value !== undefined ? (
          <Box as="strong" sx={{ fontVariantNumeric: "tabular-nums" }}>
            {value}
          </Box>
        ) : (
          <NA />
        )}
      </Skeleton>
    </Box>
  );
}
